import React from 'react';

const AddClient =React.lazy(()=>import('./AddClient'));
const ClientDetail =React.lazy(()=>import('./ClientDetails'));
const ClientList =React.lazy(()=>import('./ClientList'));

export {
    AddClient,
    ClientDetail,
    ClientList
}